<template>
  <PageSection
    :use-alternate-bg-color="useAlternateBgColor"
    :class="$style.csrWhy"
  >
    <PageContainer>
      <PageTwoColumnsContent
        :image="items.image"
        :content="items.content"
      />
    </PageContainer>
  </PageSection>
</template>

<script lang="ts">
import PageTwoColumnsContent, { PageTwoColumnsContentProps } from '@/scripts/pages/onepager/components/PageTwoColumnsContent.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import { CsrBaseComponent } from '../components/CsrBaseComponent';
import { WHY_SECTION_IMAGE } from '../assets/media';

export default CsrBaseComponent.extend({
  components: {
    PageTwoColumnsContent,
    PageSection,
    PageContainer,
  },
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const items: PageTwoColumnsContentProps = {
      image: WHY_SECTION_IMAGE,
      content: {
        title: this.$t('csr.section.why.title'),
        paragraphs: this.$t('csr.section.why.paragraphs'),
      },
    };

    return {
      items,
    };
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.csrWhy {
  font-size: 1.12500rem;
}
</style>
